import React, { useState } from 'react'
import { UpdatePaymentResponse, UpdateResult } from '../../http/protocol'
import { getContainer } from '../../ioc/IOCSetup'
import { Modal, Spinner } from 'react-bootstrap';
import { BrandButton } from '../../ui/buttons/buttons';
import { t } from '../../i18n';
import { Status } from '../../journey/UserJourneyReducer';

interface WithdrawCancellationProps {
    paymentId?: number;
    isOpen?: boolean;
    onHide?: () => void;
    onSuccess?: () => void;
}

export default function WithdrawCancellation({ paymentId = 0, isOpen, onHide, onSuccess }: WithdrawCancellationProps): JSX.Element {

    const [isCancellationSuccess, setIsCancellationSuccess] = useState<UpdateResult | undefined>(undefined)
    const [asyncStatus, setAsyncStatus] = useState<Status>(Status.NONE)

    const handleCancellation = (response: UpdatePaymentResponse) => {
        if (!response) {
            throw new Error('error response')
        }
        if (response.result == UpdateResult.OK) {
            setIsCancellationSuccess(UpdateResult.OK)
            onSuccess?.();
        } else {
            setIsCancellationSuccess(UpdateResult.ERROR)
        }
    }


    // Not in use, will be implemented in upcomming sprints.
    const performPaymentCancellation = async (id: string) => {
        setAsyncStatus(Status.LOADING)
        try {
            // Disabled for now - returns error
            setIsCancellationSuccess(UpdateResult.ERROR)
            setAsyncStatus(Status.ERROR);

            // Original code disabled
            /*
            const response = await new Promise<UpdatePaymentResponse>((resolve, reject) => {
                getContainer().getTransactionService().cancelPayment(id)
                    .then(resolve)
                    .catch(reject);
            })
            handleCancellation(response)
            setAsyncStatus(Status.DONE);
            */

        } catch (error) {
            console.error("Cancellation error, with paymentId =", id)
            setIsCancellationSuccess(UpdateResult.ERROR)
            setAsyncStatus(Status.ERROR);
        }
    }

    const closeModal = () => {
        setIsCancellationSuccess(undefined);
        onHide?.();
    };

    return (
        <Modal centered show={isOpen} onHide={closeModal} className="cancellation-modal">
            <Modal.Header closeButton className="cancellation-modal__header" />
            <Modal.Body className="cancellation-modal__body">
                <div className="cancellation-modal__content">
                    {asyncStatus == Status.LOADING && (
                        <div className="cancellation-modal__section cancellation-modal__section--loading">
                            <Spinner className='cancel-request-spinner' animation={'border'} />
                        </div>
                    )}
                    {asyncStatus !== Status.LOADING && isCancellationSuccess == undefined && (
                        <div className="cancellation-modal__section cancellation-modal__section--confirm">
                            <p className="cancellation-modal__text">{t('transactions.cancellation-request-modal.confirm-cancel')}</p>
                            <BrandButton
                                className="btn btn-cta cancellation-modal__button cancellation-modal__button--cancel"
                                onClick={() => performPaymentCancellation(paymentId.toString())}
                            >
                                {t('transactions.cancellation-request-modal.cancel-button')}
                            </BrandButton>
                        </div>
                    )}
                    {asyncStatus !== Status.LOADING && isCancellationSuccess == UpdateResult.OK && (
                        <div className="cancellation-modal__section cancellation-modal__section--pending">
                            <p className="cancellation-modal__text">{t('transactions.cancellation-request-modal.cancel-success')}</p>
                            <BrandButton
                                className="btn btn-cta cancellation-modal__button cancellation-modal__button--close"
                                onClick={closeModal}
                            >
                                {t('transactions.cancellation-request-modal.close-button')}
                            </BrandButton>
                        </div>
                    )}
                    {asyncStatus !== Status.LOADING && isCancellationSuccess == UpdateResult.ERROR && (
                        <div className="cancellation-modal__section cancellation-modal__section--error">
                            <p className="cancellation-modal__text">{t('transactions.cancellation-request-modal.error-message')}</p>
                            <BrandButton
                                className="btn btn-cta cancellation-modal__button cancellation-modal__button--close"
                                onClick={closeModal}
                            >
                                {t('transactions.cancellation-request-modal.close-button')}
                            </BrandButton>
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    )
}
